import React, { useEffect, useState } from 'react';
import { Button, Table, Tooltip, message } from 'antd';
import { listSyncConflicts, resolveSyncConflict } from '../../services/customerImportApi';

// Story 2.3 (AD-8): lists open address-sync conflicts -- "Mark Reviewed" only
// acknowledges the conflict (sets conflict_status='resolved'), it does not
// reconcile the underlying data, so the same conflict can reopen on the next
// sync run if nothing about the address actually changed. See the story's
// Dev Notes.
export default function SyncConflictsPanel() {
  const [conflicts, setConflicts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resolvingId, setResolvingId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const data = await listSyncConflicts();
      setConflicts(data || []);
    } catch (err) {
      message.error(err.message || 'Could not load sync conflicts.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleResolve = async (conflictId) => {
    setResolvingId(conflictId);
    try {
      await resolveSyncConflict(conflictId);
      message.success('Conflict marked reviewed.');
      await load();
    } catch (err) {
      message.error(err.message || 'Could not resolve conflict.');
    } finally {
      setResolvingId(null);
    }
  };

  const columns = [
    {
      title: 'Address',
      key: 'address',
      render: (_, record) => [record.address_line1, record.city].filter(Boolean).join(', ') || '—',
    },
    { title: 'Detected', dataIndex: 'conflict_detected_at' },
    {
      title: '',
      key: 'actions',
      render: (_, record) => (
        <Tooltip title="Acknowledges the conflict; does not change the address data.">
          <Button size="small" loading={resolvingId === record.id} onClick={() => handleResolve(record.id)}>
            Mark Reviewed
          </Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      size="small"
      loading={loading}
      dataSource={conflicts}
      columns={columns}
      pagination={false}
      locale={{ emptyText: 'No open sync conflicts.' }}
    />
  );
}
